import React from 'react';
import CustomMap from "./CustomMap";
import PlacesWithStandaloneSearchBox from "./PlacesWithStandaloneSearchBox";
import Paper from "@material-ui/core/Paper";
import axios from "axios";
import {
    calculateProperCenteredNoFlyPolygonCoords,
    calculateProperCenteredPolygonCoords,
    computeScanningDensity, computeVerticalSpeed,
    getCentroidAreaCoverage, getCentroidScatteredRegionsOfInterest,
    getRandomColor
} from "../utils/utils";
import LinearProgress from "@material-ui/core/LinearProgress";
import _, {debounce} from "lodash";
import Sidebar from "./SideBar";
import {Client} from "@stomp/stompjs";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import {Tab, Tabs} from "@material-ui/core";
import {
    convertAreaCoveragePathsPortionsGeo,
    convertRefsToMultiPolygonGeo,
    convertRefToMultiPointGeo,
    convertRefToPolygonGeo, convertScatteredRegionsVisitationPathsGeo,
    convertWaypointsWithAltitude,
    initializeAreaCoveragePaths,
    transformAreaCoverage,
    transformAreaCoveragePathsFromGeoJSON,
    transformScatteredAreasOfInterest,
    transformScatteredRegionsOfInterest,
    transformScatteredRegionsVisitation
} from "../utils/PolygonHelper";
import LivePlayer from "./LivePlayer";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const nginxHLS = "nginx-rtmp"
const nginxHLSport = process.env.NGINX_RTMP_DOCKER_PORT

const mapCss = {
    position: 'fixed',
    zIndex: '-1',

    right: 0,
    width: '78vw',
    height: '100vh',
    marginRight: '0'
}

const searchBoxCss = {
    position: 'fixed',
    right: '37%',
    width: '200px',
    paddingBottom: '10px',
    margin: 'auto',
    opacity: 0.85,
    borderRadius: '15px',
    boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
}


class Main extends React.Component {

    state = {

        projects: [],

        selectedProjectType: null,

        areaCoverageProject: {
            portions: [],
            areaOfInterestRef: null,
            noFlyZonesRefs: [],
            initialPositionsRefs: [],
            areaOfInterestArea: 0
        },

        scatteredRegionsVisitationProject: {
            scatteredRegionsOfInterestRefs: [],
            initialPositionsRefs: [],
            scatteredRegionsOfInterestArea: 0
        },

        deploymentStatus: null,
        deploymentAreaCoverageForm: {
            droneCanonicalNames: [],
            flightPathMode: 'NORMAL',
            finishedAction: 'GO_HOME',
            cameraMode: 'SHOOT_PHOTO_INTERVAL',
            shootPhotoIntervalDetails: {captureCount: 200, timeIntervalInSeconds: 3},
            shootPhotoWaypointsDetails: {},
            liveStreamingDetails: {},

            gimbalPitch: -87,
            speed: 10
        },
        deploymentAreaCoverageFormErrors: [],
        estimatedExperimentTime: 0,

        mapLocation: {
            lat: 40.933702,
            lng: 24.412381
        },
        initialLocation: {
            lat: 40.933702,
            lng: 24.412381
        },

        initialUAVPosition: [],
        resetOperationalArea: false,

        runDeploymentButtonDisabled: true,

        editingPolygons: true,

        waypoints: [],
        waypointsColors: [],

        loading: false,
        darpLoading: false,
        executeScatteredRegionsLoading: false,

        numberOfDronesChangeLoading: false,

        mapRef: null,
        initialUAVPositionRef: null,

        dronesLive: {},
        dronesSubscribed: {},
        dronesConfig: [],
        droneStatuses: {},

        polygonBackgroundColor: '#250303',
        polygonBackgroundColorCheck: false,

        tab: 0,
    };

    // refreshDronesSubscribed = (drones) => {
    //     // console.log(drones.keys())
    //     // console.log(droneCanonicalNames);
    //     this.setState({dronesSubscribed: [...Object.keys(drones)]});
    // };

    // Debounced function
    constructor(props) {
        super(props);
        this.onNumberOfDronesChange = debounce(this.onNumberOfDronesChange.bind(this), 300);
    }

    getProjects = () => {
        axios.get('/api/projects').then(res => {
            this.setState({
                projects: res.data,

                selectedProjectType: null,

                areaCoverageProject: {
                    portions: [],
                    areaOfInterestRef: null,
                    noFlyZonesRefs: [],
                    initialPositionsRefs: []
                },

                scatteredRegionsVisitationProject: {
                    scatteredRegionsOfInterestRefs: [],
                    initialPositionsRefs: []
                },
            })
        })
    }

    componentDidMount() {

        this.getProjects();


        navigator.geolocation.getCurrentPosition(
            position => {
                const {latitude, longitude} = position.coords;


                this.setState({
                    browserLocation: {lat: latitude, lng: longitude},
                    loading: false
                });
            },
            (err) => {
                console.log(`error getting browser's geolocation ${err}`)
                this.setState({loading: false});
            }
        );

        axios.get('/api/drones').then(res => {

            this.setState({
                dronesConfig: res.data
            });
        })

        this.refreshDroneTelemetry();

        let intervalIdTrackingInfos = setInterval(() => {
            this.refreshDroneTelemetry();
        }, 2000);

        let intervalArea = setInterval(() => {
            this.calculateArea()
        }, 500)

        this.setState({
            intervalIdTrackingInfos,
             intervalArea
        })

        this.client = new Client();

        let brokerURL

        if(window.location.host === "localhost:3000") {
            brokerURL = 'ws://localhost:9011/stomp'
        } else {
            brokerURL = 'wss://' + window.location.host + '/stomp'
        }

        this.client.configure({

            brokerURL: brokerURL,
            onConnect: () => {

                // this.client.subscribe('/topic/drones', message => {
                //
                //     const drone = JSON.parse(message.body);
                //
                //     if (this.state.dronesSubscribed[drone.canonicalName]) {
                //         this.updateDrones(drone);
                //     }
                //
                // })
                this.client.subscribe('/topic/drone-telemetry', message => {
                    const droneTelemetry = JSON.parse(message.body);
                    this.updateDroneTelemetry(droneTelemetry);
                })

                this.client.subscribe('/topic/darpError', message => {
                    this.updateInfoSnackbar(message.body);
                })

            }
        })

        this.client.activate();

    }

    componentWillUnmount() {
        clearInterval(this.state.intervalIdTrackingInfos);
        clearInterval(this.state.intervalIdExperiment);
        clearInterval(this.state.intervalArea);
    }

    onSearchBoxSelection = (mapLocation) => {

        this.setState({
            mapLocation: mapLocation,
            // paths: [
            //     {lat: mapLocation.lat - .0015, lng: mapLocation.lng - .002},
            //     {lat: mapLocation.lat - .0015, lng: mapLocation.lng + .002},
            //     {lat: mapLocation.lat + .0015, lng: mapLocation.lng + .002},
            //     {lat: mapLocation.lat + .0015, lng: mapLocation.lng - .002},
            // ],
            // paths: calculateProperCenteredPolygonCoords(this.state.mapRef.getBounds().getNorthEast(), mapLocation),
        })
    };

    onPortionsChange = (event, newValue, index) => {

        if (this.state.selectedProjectType === "AREA_COVERAGE") {
            let areaCoverageProject = {...this.state.areaCoverageProject}
            let portions = [...areaCoverageProject.portions]
            portions[index] = newValue
            areaCoverageProject.portions = portions
            this.setState( {
                areaCoverageProject
            })
        }
    };

    onAddNoFlyZoneClick = () => {

        let mapCenterLocation = {lat: this.state.mapRef.getCenter().lat(), lng: this.state.mapRef.getCenter().lng()};

        let project = {...this.state.areaCoverageProject}

        project.noFlyZones = [...project.noFlyZones, calculateProperCenteredNoFlyPolygonCoords(
            this.state.mapRef.getBounds().getNorthEast(), mapCenterLocation)]
        this.setState({
            areaCoverageProject: project
        });
    };

    onAddPolygonClick = () => {

        let mapCenterLocation = {lat: this.state.mapRef.getCenter().lat(), lng: this.state.mapRef.getCenter().lng()};

        let scatteredRegionsVisitationProject = {...this.state.scatteredRegionsVisitationProject}

        let scatteredRegionsOfInterest = [...scatteredRegionsVisitationProject.scatteredRegionsOfInterest]


        scatteredRegionsOfInterest = [...scatteredRegionsOfInterest, calculateProperCenteredNoFlyPolygonCoords(this.state.mapRef.getBounds().getNorthEast(), mapCenterLocation)];

        this.setState({
            scatteredRegionsVisitationProject: {
                ...scatteredRegionsVisitationProject,
                scatteredRegionsOfInterest: scatteredRegionsOfInterest
            }
        });
    };

    onProjectCheckboxChange = (name, evt) => {

        if (this.state.selectedProjectType === "AREA_COVERAGE") {
            const project = {...this.state.areaCoverageProject}
            project[name] = evt.target.checked;
            this.setState({
                areaCoverageProject: project
            })
        } else if (this.state.selectedProjectType === "SCATTERED_REGIONS_VISITATION") {
            const project = {...this.state.scatteredRegionsVisitationProject}
            project[name] = evt.target.checked;
            this.setState({
                scatteredRegionsVisitationProject: project
            })
        }
    }

    onNumberOfDronesChange(value) {

        let previousNumberOfDrones = parseInt(this.state.areaCoverageProject.numberOfDrones);

        let newNumberOfDrones = parseInt(value);

        if (value < 1) {
            newNumberOfDrones = "1";
            return
        }

        this.setState({
            numberOfDronesChangeLoading: true
        })

        if(previousNumberOfDrones < newNumberOfDrones) {
            axios.post('/api/randomPointInsidePolygon', {
                areaOfInterest: convertRefToPolygonGeo(this.state.areaCoverageProject.areaOfInterestRef),
                noFlyZones: convertRefsToMultiPolygonGeo(this.state.areaCoverageProject.noFlyZonesRefs),
            })
                .then(response => {

                    if(response.data && response.data.coordinates) {
                        let project = {...this.state.areaCoverageProject}
                        let pGeo = response.data.coordinates
                        let initialPositions = [...project.initialPositions]
                        initialPositions.push({lat: pGeo[1], lng: pGeo[0]})
                        project.initialPositions = initialPositions
                        project.initialPositionsRefs = []

                        project.numberOfDrones = newNumberOfDrones.toString()
                        let portions = Array.from({length: newNumberOfDrones}, (v, i) => 100 / newNumberOfDrones);
                        project.portions = portions

                        project.areaCoveragePaths = []
                        project.areaCoveragePathColors = []

                        this.setState(
                            {
                                areaCoverageProject: project,
                                numberOfDronesChangeLoading: false
                            }
                        )
                    }
                }).catch(error => {
                    let message = error.response.data.message
                    console.log("what an error")
                    this.setState(
                        {
                            numberOfDronesChangeLoading: false
                        })
                    this.updateInfoSnackbar(message);
            })
        } else if (previousNumberOfDrones > newNumberOfDrones) {

            let project = {...this.state.areaCoverageProject}
            let initialPositions = [...project.initialPositions]
            initialPositions.pop()
            project.numberOfDrones = newNumberOfDrones.toString()

            project.initialPositions = initialPositions
            project.initialPositionsRefs = []

            let portions = Array.from({length: newNumberOfDrones}, (v, i) => 100 / newNumberOfDrones);
            project.portions = portions

            project.areaCoveragePaths = []
            project.areaCoveragePathColors = []

            this.setState(
                {
                    areaCoverageProject: project,
                    numberOfDronesChangeLoading: false
                }
            )
        }
    }

    onProjectChange = (name, evt) => {

        if (this.state.selectedProjectType === "AREA_COVERAGE") {
            const project = {...this.state.areaCoverageProject}
            project[name] = evt.target.value;

            this.setState({
                areaCoverageProject: project,
            });
        } else if (this.state.selectedProjectType === "SCATTERED_REGIONS_VISITATION") {
            const project = {...this.state.scatteredRegionsVisitationProject}
            project[name] = evt.target.value;

            this.setState({
                scatteredRegionsVisitationProject: project,
            });
        }
    }

    onDeploymentAreaCoverageFormChange = (name, evt) => {

        const deploymentAreaCoverageForm = {...this.state.deploymentAreaCoverageForm}

        if(name.includes(".")) {
            let [prop1, prop2] = name.split(".");
            deploymentAreaCoverageForm[prop1][prop2] = evt.target.value;
        } else {
            deploymentAreaCoverageForm[name] = evt.target.value;
        }

        // debugger;
        let deploymentAreaCoverageFormErrors = {...this.state.deploymentAreaCoverageFormErrors};
        switch (name) {
            // case "scanDist":
            //     if (!(deploymentAreaCoverageForm["scanDist"] >= 3 && deploymentAreaCoverageForm["scanDist"] <= 1000)) {
            //         deploymentAreaCoverageFormErrors["scanDist"] = "value should be between 3 and 1000"
            //     } else {
            //         delete deploymentAreaCoverageFormErrors["scanDist"];
            //     }
            //     break;
            case "speed":
                if (!(deploymentAreaCoverageForm["speed"] > 2 && deploymentAreaCoverageForm["speed"] <= 13)) {
                    deploymentAreaCoverageFormErrors["speed"] = "value should be greater than 2 and less than 13"
                } else {
                    delete deploymentAreaCoverageFormErrors["speed"];
                    this.calculateEstimatedDeploymentTime(deploymentAreaCoverageForm["speed"]);
                }
                break;
            case "gimbalPitch":
                if (!(deploymentAreaCoverageForm["gimbalPitch"] <= 0 && deploymentAreaCoverageForm["gimbalPitch"] >= -90)) {
                    deploymentAreaCoverageFormErrors["gimbalPitch"] = "value should be between 0 and -90"
                } else {
                    delete deploymentAreaCoverageFormErrors["gimbalPitch"];
                }
                break;
            case "droneCanonicalNames":
                this.calculateEstimatedDeploymentTime(deploymentAreaCoverageForm["speed"]);
                break;

        }
        ;

        this.setState({
            deploymentAreaCoverageForm,
            deploymentAreaCoverageFormErrors,
        });
    }

    calculateEstimatedDeploymentTime = (speed) => {

        axios.post('/api/calculate-estimated-deployment-time', {
            waypoints: convertWaypointsWithAltitude(this.state.areaCoverageProject.areaCoveragePaths, this.state.areaCoverageProject.altitude),
            speed: speed ? speed : this.state.deploymentAreaCoverageForm.speed
        })
            .then(response => {
                this.setState(
                    {
                        estimatedDeploymentTime: response.data,
                        runDeploymentButtonDisabled: response.data >= 25,
                    }
                )
            });
    }

    onClickProject = (project) => {

        if(project.type === "AREA_COVERAGE") {
            let [areaOfInterest,
                noFlyZones,
                areaCoveragePaths,
                portions,
                initialPositions] =
                transformAreaCoverage(project)

            if(areaCoveragePaths.length === 0) {
                areaCoveragePaths = []
            }

            let areaCoveragePathColors = [];
            if (areaCoveragePaths) {
                areaCoveragePathColors = areaCoveragePaths.map(_ => {
                    return getRandomColor();
                });
            }

            let centroid = getCentroidAreaCoverage(areaOfInterest);

            this.setState({
                selectedProjectType: "AREA_COVERAGE",
                areaCoverageProject: {
                    ...project,
                    areaOfInterestRef: null,
                    areaOfInterest,
                    portions,
                    initialPositions,
                    initialPositionsRefs: [],
                    noFlyZones,
                    noFlyZonesRefs: [],
                    areaCoveragePaths,
                    areaCoveragePathColors
                },
                mapLocation: centroid
            }, () => {


                    if (this.state.areaCoverageProject.areaOfInterestRef && this.state.mapRef) {

                        let paths_ = this.state.areaCoverageProject.areaOfInterestRef.getPaths();

                        let bounds = new window.google.maps.LatLngBounds();
                        console.log("bounds: ", bounds)

                        console.log("paths_:", paths_);

                        let path;
                        for (let i = 0; i < paths_.getLength(); i++) {
                            path = paths_.getAt(i);
                            for (let ii = 0; ii < path.getLength(); ii++) {
                                console.log(path.getAt(ii))
                                bounds.extend(path.getAt(ii))
                            }
                        }

                        console.log("bounds: ", bounds)
                        this.state.mapRef.fitBounds(bounds);
                    }
                });
        }
        else if (project.type === "SCATTERED_REGIONS_VISITATION") {

            let [scatteredRegionsOfInterest, scatteredRegionsVisitationPaths, initialPositions] = transformScatteredRegionsVisitation(project)

            if(scatteredRegionsVisitationPaths.length === 0) {
                scatteredRegionsVisitationPaths = []
            }

            let scatteredRegionsVisitationPathColors = [];
            if (scatteredRegionsVisitationPaths) {
                scatteredRegionsVisitationPathColors = scatteredRegionsVisitationPaths.map(_ => {
                    return getRandomColor();
                });
            }

            let centroid = getCentroidScatteredRegionsOfInterest(scatteredRegionsOfInterest);

            this.setState({
                selectedProjectType: "SCATTERED_REGIONS_VISITATION",
                scatteredRegionsVisitationProject: {
                    ...project,
                    scatteredRegionsOfInterest,
                    scatteredRegionsOfInterestRefs: [],
                    initialPositions,
                    initialPositionsRefs: [],
                    scatteredRegionsVisitationPaths,
                    scatteredRegionsVisitationPathColors
                },
                mapLocation: centroid
            }, () => {
                if (this.state.scatteredRegionsVisitationProject.scatteredRegionsOfInterestRefs
                    && this.state.scatteredRegionsVisitationProject.scatteredRegionsOfInterestRefs.length > 0 && this.state.mapRef) {

                    let paths_ = [];
                    paths_ = this.state.scatteredRegionsVisitationProject.scatteredRegionsOfInterestRefs[0].getPaths();

                    let bounds = new window.google.maps.LatLngBounds();
                    console.log("bounds: ", bounds)

                    console.log("paths_:", paths_);

                    let path;
                    for (let i = 0; i < paths_.getLength(); i++) {
                        path = paths_.getAt(i);
                        for (let ii = 0; ii < path.getLength(); ii++) {
                            console.log(path.getAt(ii))
                            bounds.extend(path.getAt(ii))
                        }
                    }

                    console.log("bounds: ", bounds)
                    this.state.mapRef.fitBounds(bounds);
                }
            });
        }

        // this.setState({
        //     project: {
        //         ...this.state.project,
        //         scatteredAreasOfInterest,
        //         areaOfInterest
        //     },
        //     waypointsColors,
        //     mapLocation: centroid
        // }, () => {
        //
        //
        //     if ((this.state.areaOfInterestRef ||
        //             this.state.scatteredAreasOfInterestRefs && this.state.scatteredAreasOfInterestRefs.length > 0)
        //         && this.state.mapRef) {
        //
        //         debugger
        //         let paths_ = [];
        //         if(this.state.areaOfInterestRef) {
        //             paths_ = this.state.areaOfInterestRef.getPaths();
        //         } else {
        //             paths_ = this.state.scatteredAreasOfInterestRefs[0].getPaths();
        //         }
        //
        //         let bounds = new window.google.maps.LatLngBounds();
        //         console.log("bounds: ", bounds)
        //
        //         console.log("paths_:", paths_);
        //         let path;
        //         for (let i = 0; i < paths_.getLength(); i++) {
        //             path = paths_.getAt(i);
        //             for (let ii = 0; ii < path.getLength(); ii++) {
        //                 console.log(path.getAt(ii))
        //                 bounds.extend(path.getAt(ii))
        //             }
        //         }
        //
        //         console.log("bounds: ", bounds)
        //         this.state.mapRef.fitBounds(bounds);
        //     }
        // });

        //
        // let initialUAVPosition = [];
        // if (project.type === 'SCATTERED_REGIONS_VISITATION') {
        //
        //     initialUAVPosition =
        //     project.initialPositionJSON && project.initialPositionJSON.length > 0 ? {lat: project.initialPositionJSON[0], lng: project.initialPositionJSON[1]} : centroidMulti;
        // }

        // this.setState({
        //     project: project,
        //     portions: portions,
        //     paths: paths,
        //     initialUAVPosition: initialUAVPosition,
        //     waypoints: waypoints,
        //     waypointsColors: waypointsColors,
        //     obstaclePaths: obstaclePaths,
        //     mapLocation: centroidMulti,
        // }, () => {
        //
        //     if (this.state.polygonRefs && this.state.polygonRefs.length > 0 && this.state.mapRef) {
        //         debugger
        //         let bounds = new window.google.maps.LatLngBounds();
        //         console.log("bounds: ", bounds)
        //         let paths_ = this.state.polygonRefs[0].getPaths();
        //         console.log("paths_:", paths_);
        //         let path;
        //         for (let i = 0; i < paths_.getLength(); i++) {
        //             path = paths_.getAt(i);
        //             for (let ii = 0; ii < path.getLength(); ii++) {
        //                 console.log(path.getAt(ii))
        //                 bounds.extend(path.getAt(ii))
        //             }
        //         }
        //
        //         console.log("bounds: ", bounds)
        //         this.state.mapRef.fitBounds(bounds);
        //     }
        // })
    }

    onNewProject = (projectType) => {

        if(projectType === "AREA_COVERAGE") {
            let areaCoverageProject = {};
            areaCoverageProject.type = projectType;
            areaCoverageProject.name = "";
            areaCoverageProject.numberOfDrones = 1;
            areaCoverageProject.altitude = 30;
            areaCoverageProject.percentageOfSidelap = 50;
            areaCoverageProject.pathsStrictlyInPoly = true;
            areaCoverageProject.portions = [100]
            areaCoverageProject.areaCoveragePaths = []
            areaCoverageProject.areaCoveragePathColors = []
            areaCoverageProject.areaOfInterestArea = 0

            let mapCenterLocation = {lat: this.state.mapRef.getCenter().lat(), lng: this.state.mapRef.getCenter().lng()};

            let areaOfInterest = calculateProperCenteredPolygonCoords(this.state.mapRef.getBounds().getNorthEast(), mapCenterLocation)
            areaCoverageProject.areaOfInterest = areaOfInterest;
            let centroid = getCentroidAreaCoverage(areaCoverageProject.areaOfInterest);
            areaCoverageProject.initialPositions = [centroid]
            areaCoverageProject.areaOfInterestRef = null
            areaCoverageProject.noFlyZones = []
            areaCoverageProject.noFlyZonesRefs = []
            areaCoverageProject.initialPositionsRefs = []

            this.setState({
                resetOperationalArea: true,
                selectedProjectType: "AREA_COVERAGE",
                areaCoverageProject,
                runDeploymentButtonDisabled: true,
            })
        } else if (projectType === 'SCATTERED_REGIONS_VISITATION') {
            let scatteredRegionsVisitationProject = {}
            scatteredRegionsVisitationProject.type = projectType;
            scatteredRegionsVisitationProject.name = "";
            scatteredRegionsVisitationProject.numberOfDrones = 1;
            scatteredRegionsVisitationProject.droneType = 'DJI_PHANTOM_4_PRO';
            scatteredRegionsVisitationProject.maxAltitude = 120;
            scatteredRegionsVisitationProject.minAltitude = 20;
            scatteredRegionsVisitationProject.flightAltitude = 50;
            scatteredRegionsVisitationProject.horizontalSpeed = 5;


            scatteredRegionsVisitationProject.safetyFactor = 0.8;
            scatteredRegionsVisitationProject.iouMetric = false
            scatteredRegionsVisitationProject.scatteredRegionsOfInterestArea = 0
            scatteredRegionsVisitationProject.droneType= "DJI_PHANTOM_4_PRO"
            scatteredRegionsVisitationProject.hcoeff = 0.9
            scatteredRegionsVisitationProject.vcoeff = 0.1

            scatteredRegionsVisitationProject.verticalSpeed = computeVerticalSpeed(this.state.dronesConfig,
                scatteredRegionsVisitationProject.droneType,
                scatteredRegionsVisitationProject.horizontalSpeed);
            
            let mapCenterLocation = {lat: this.state.mapRef.getCenter().lat(), lng: this.state.mapRef.getCenter().lng()};
            
            let scatteredRegionsOfInterest = [calculateProperCenteredPolygonCoords(this.state.mapRef.getBounds().getNorthEast(), mapCenterLocation)]
            scatteredRegionsVisitationProject.scatteredRegionsOfInterest = scatteredRegionsOfInterest;
            let centroid = getCentroidScatteredRegionsOfInterest(scatteredRegionsOfInterest);
            scatteredRegionsVisitationProject.initialPositions = [centroid]
            scatteredRegionsVisitationProject.scatteredRegionsOfInterestRefs = []
            scatteredRegionsVisitationProject.initialPositionsRefs = []
            scatteredRegionsVisitationProject.scatteredRegionsVisitationPaths = []
            scatteredRegionsVisitationProject.scatteredRegionsVisitationPathColors = []
            
            this.setState({
                resetOperationalArea: true,
                selectedProjectType: 'SCATTERED_REGIONS_VISITATION',
                scatteredRegionsVisitationProject,
                runDeploymentButtonDisabled: true
            })

        }

    }

    onSaveAreaCoverageProject = () => {
        let areaCoverageProject = {...this.state.areaCoverageProject};
        console.log("areaCoverageProject", areaCoverageProject)
        let areaCoverageProjectRequest = {}

        if(areaCoverageProject.id) {
            areaCoverageProjectRequest.id = areaCoverageProject.id
        }

        areaCoverageProjectRequest.name = areaCoverageProject.name
        areaCoverageProjectRequest.numberOfDrones = areaCoverageProject.numberOfDrones
        areaCoverageProjectRequest.type = areaCoverageProject.type
        areaCoverageProjectRequest.areaOfInterest = convertRefToPolygonGeo(areaCoverageProject.areaOfInterestRef)
        areaCoverageProjectRequest.areaOfInterestArea = areaCoverageProject.areaOfInterestArea
        areaCoverageProjectRequest.initialPositions = convertRefToMultiPointGeo(areaCoverageProject.initialPositionsRefs)
        areaCoverageProjectRequest.percentageOfSidelap = areaCoverageProject.percentageOfSidelap
        areaCoverageProjectRequest.pathsStrictlyInPoly = areaCoverageProject.pathsStrictlyInPoly
        areaCoverageProjectRequest.altitude = areaCoverageProject.altitude
        areaCoverageProjectRequest.noFlyZones = convertRefsToMultiPolygonGeo(areaCoverageProject.noFlyZonesRefs)
        areaCoverageProjectRequest.areaCoveragePaths = convertAreaCoveragePathsPortionsGeo(areaCoverageProject.areaCoveragePaths,
            areaCoverageProject.portions)

        axios.post('/api/project', areaCoverageProjectRequest).then(response => {

            let project = response.data.project;
            const [areaOfInterest, noFlyZones, areaCoveragePaths, portions,
                initialPositions] =
                transformAreaCoverage(project)

            let areaCoveragePathColors = [];
            if (areaCoveragePaths) {
                areaCoveragePathColors = areaCoveragePaths.map(_ => {
                    return getRandomColor();
                });
            }

            let centroid = getCentroidAreaCoverage(areaOfInterest);


            this.setState({
                selectedProjectType: "AREA_COVERAGE",
                areaCoverageProject: {
                    ...areaCoverageProject,
                    id: project.id,
                    name: project.name,
                    numberOfDrones: project.numberOfDrones,
                    type: project.type,
                    percentageOfSidelap: project.percentageOfSidelap,
                    pathsStrictlyInPoly: project.pathsStrictlyInPoly,
                    altitude: project.altitude,
                    areaOfInterestRef: null,
                    areaOfInterest,
                    initialPositions,
                    portions,
                    initialPositionsRefs: [],
                    noFlyZones,
                    noFlyZonesRefs: [],
                    areaCoveragePaths,
                    areaCoveragePathColors
                },
                mapLocation: centroid
            })
        })
    }


    onSaveScatteredRegionsVisitationProject = () => {

        let scatteredRegionsVisitationProject = {...this.state.scatteredRegionsVisitationProject}
        console.log("onSaveScatteredRegionsVisitationProject", scatteredRegionsVisitationProject)

        let request = {}

        if(scatteredRegionsVisitationProject.id) {
            request.id = scatteredRegionsVisitationProject.id
        }

        request.name = scatteredRegionsVisitationProject.name
        request.numberOfDrones = scatteredRegionsVisitationProject.numberOfDrones
        request.type = scatteredRegionsVisitationProject.type

        request.droneType = scatteredRegionsVisitationProject.droneType
        request.fov = scatteredRegionsVisitationProject.fov
        request.maxAltitude = scatteredRegionsVisitationProject.maxAltitude;
        request.minAltitude = scatteredRegionsVisitationProject.minAltitude;
        request.flightAltitude = scatteredRegionsVisitationProject.flightAltitude;
        request.horizontalSpeed = scatteredRegionsVisitationProject.horizontalSpeed;
        request.verticalSpeed = computeVerticalSpeed(this.state.dronesConfig,
            scatteredRegionsVisitationProject.droneType,
            scatteredRegionsVisitationProject.horizontalSpeed);
        request.hcoeff = scatteredRegionsVisitationProject.hcoeff;
        request.vcoeff = scatteredRegionsVisitationProject.vcoeff;
        request.safetyFactor = scatteredRegionsVisitationProject.safetyFactor;
        request.iouMetric = scatteredRegionsVisitationProject.iouMetric
        request.scatteredRegionsOfInterestArea = scatteredRegionsVisitationProject.scatteredRegionsOfInterestArea
        request.scatteredRegionsOfInterest = convertRefsToMultiPolygonGeo(
            scatteredRegionsVisitationProject.scatteredRegionsOfInterestRefs)

        request.initialPositions = convertRefToMultiPointGeo(
            scatteredRegionsVisitationProject.initialPositionsRefs
        )

        if(scatteredRegionsVisitationProject.scatteredRegionsVisitationPaths) {
            request.scatteredRegionsVisitationPaths = [...scatteredRegionsVisitationProject.scatteredRegionsVisitationPaths]
        }

        //     convertScatteredRegionsVisitationPathsGeo(
        //     scatteredRegionsVisitationProject.scatteredRegionsVisitationPaths
        // )

        axios.post('/api/project', request).then(response => {
            let project = response.data.project;

            const [scatteredRegionsOfInterest, scatteredRegionsVisitationPaths, initialPositions] =
                transformScatteredRegionsVisitation(project)

            let pathColors = []
            if(scatteredRegionsVisitationPaths) {
                pathColors = scatteredRegionsVisitationPaths.map(_ => {
                    return getRandomColor();
                });
            }

            let centroid = getCentroidScatteredRegionsOfInterest(scatteredRegionsOfInterest);

            this.setState({
                selectedProjectType: "SCATTERED_REGIONS_VISITATION",
                scatteredRegionsVisitationProject: {
                    ...scatteredRegionsVisitationProject,
                    id: project.id,
                    name : project.name,
                    numberOfDrones : project.numberOfDrones,
                    type : project.type,
                    droneType : project.droneType,
                    maxAltitude : project.maxAltitude,
                    minAltitude : project.minAltitude,
                    flightAltitude: project.flightAltitude,
                    horizontalSpeed: project.horizontalSpeed,
                    verticalSpeed: project.verticalSpeed,
                    safetyFactor: project.safetyFactor,
                    iouMetric: project.iouMetric,
                    scatteredRegionsOfInterestRefs: [],
                    scatteredRegionsOfInterest,
                    initialPositions,
                    initialPositionsRefs: [],

                },
                mapLocation: centroid
            })
        })

    }
    onStartDeployment = () => {

        let startDeploymentReq = {}
        // if(this.state.selectedProjectType === 'AREA_COVERAGE') {
            startDeploymentReq.speed = this.state.deploymentAreaCoverageForm.speed;
            startDeploymentReq.altitude = this.state.areaCoverageProject.altitude;
            startDeploymentReq.projectId = this.state.selectedProjectType === 'AREA_COVERAGE' ?
                this.state.areaCoverageProject.id : this.state.scatteredRegionsVisitationProject.id;
            startDeploymentReq.projectType = this.state.selectedProjectType;

            startDeploymentReq.camera = {}
            startDeploymentReq.camera.gimbalPitch = this.state.deploymentAreaCoverageForm.gimbalPitch

            startDeploymentReq.camera.details = {}

            startDeploymentReq.camera.details =
                this.state.deploymentAreaCoverageForm.cameraMode === 'SHOOT_PHOTO_INTERVAL' ?
                    this.state.deploymentAreaCoverageForm.shootPhotoIntervalDetails :
                    this.state.deploymentAreaCoverageForm.cameraMode === 'SHOOT_PHOTO_WAYPOINTS' ?
                        this.state.deploymentAreaCoverageForm.shootPhotoWaypointsDetails :
                        this.state.deploymentAreaCoverageForm.cameraMode === 'LIVE_STREAMING' ?
                            this.state.deploymentAreaCoverageForm.liveStreamingDetails : null
            startDeploymentReq.camera.details.type = this.state.deploymentAreaCoverageForm.cameraMode
            // startDeploymentReq.waypoints = convertWaypointsWithAltitude(this.state.areaCoverageProject.areaCoveragePaths, this.state.areaCoverageProject.altitude)
            startDeploymentReq.droneSerials = this.state.deploymentAreaCoverageForm.droneCanonicalNames;
            startDeploymentReq.flightPathMode = this.state.deploymentAreaCoverageForm.flightPathMode
            startDeploymentReq.finishedAction = this.state.deploymentAreaCoverageForm.finishedAction




        axios.post('/api/deployment', startDeploymentReq)
            .then(response => {
                const startDeploymentResponse = response.data;
                if (startDeploymentResponse.result === "OK") {
                    this.setState({
                        deploymentId: response.data.deploymentId,
                        runDeploymentButtonDisabled: true,
                    })
                }

                let intervalIdExperiment = setInterval(() => {
                    axios.get(`/api/deployment/${this.state.deploymentId}`).then(res => {


                        let deployment = res.data;

                        let droneStatuses = {...this.state.droneStatuses};

                        deployment.waypointMissions.forEach(mission => {
                            droneStatuses[mission.canonicalName] = mission.missionStatus;
                        })
                        console.log("deployment status:" + deployment.deploymentStatus)
                        this.setState({
                            deploymentStatus: deployment.deploymentStatus,
                            droneStatuses
                        })

                        if (deployment.deploymentStatus !== "ONGOING") {
                            clearInterval(intervalIdExperiment)
                        }
                    })
                }, 2000)

                this.setState({
                    intervalIdExperiment
                })
            })
    }

    onAbortExperiment = () => {
        axios.post('/api/abort', {experimentId: this.state.experimentId});
        this.setState({
            runDeploymentButtonDisabled: false,
        })
    }

    onResetRegionOfInterest = (type) => (evt) => {


        let mapCenterLocation = {lat: this.state.mapRef.getCenter().lat(), lng: this.state.mapRef.getCenter().lng()};

        if(type === 'AREA_COVERAGE') {


            let areaOfInterest = calculateProperCenteredPolygonCoords(this.state.mapRef.getBounds().getNorthEast(), mapCenterLocation)

            let areaCoverageProject = {...this.state.areaCoverageProject}
            areaCoverageProject.areaOfInterest = areaOfInterest
            areaCoverageProject.areaOfInterestRef = null

            let centroid = getCentroidAreaCoverage(areaOfInterest);
            areaCoverageProject.initialPositions = [centroid]
            areaCoverageProject.numberOfDrones = 1
            areaCoverageProject.portions = [100]
            areaCoverageProject.initialPositionsRefs = []


            areaCoverageProject.noFlyZonesRefs = []
            areaCoverageProject.noFlyZones = []

            areaCoverageProject.areaCoveragePaths = []
            areaCoverageProject.areaCoveragePathColors = []


            this.setState({
                areaCoverageProject,
                resetOperationalArea: true,
                runDeploymentButtonDisabled: true,
            })
        } else if (type === 'SCATTERED_REGIONS_VISITATION') {
            let scatteredRegionsOfInterest = [calculateProperCenteredPolygonCoords(this.state.mapRef.getBounds().getNorthEast(), mapCenterLocation)]
            let scatteredRegionsVisitationProject = {...this.state.scatteredRegionsVisitationProject}
            scatteredRegionsVisitationProject.scatteredRegionsOfInterest = scatteredRegionsOfInterest
            scatteredRegionsVisitationProject.scatteredRegionsOfInterestRefs = []

            let centroid = getCentroidScatteredRegionsOfInterest(scatteredRegionsOfInterest);
            scatteredRegionsVisitationProject.initialPositions =  [centroid]
            scatteredRegionsVisitationProject.initialPositionsRefs = []
            scatteredRegionsVisitationProject.fov = null
            scatteredRegionsVisitationProject.scatteredRegionsVisitationPaths = []
            scatteredRegionsVisitationProject.scatteredRegionsVisitationPathColors = []

            this.setState({
                scatteredRegionsVisitationProject,
                resetOperationalArea: true,
                runDeploymentButtonDisabled: true,
            })
        }

    };

    setMapRef = (node) => {

        if (this.state.mapRef === null)
            this.setState({
                mapRef: node
            })
    }

    setInitialPositionRef = (node, index) => {

        if (node == null) {
            return;

        }

        if(this.state.selectedProjectType === "AREA_COVERAGE") {
            let areaCoverageProject = {...this.state.areaCoverageProject}

            let initialPositionRefs = [...areaCoverageProject.initialPositionsRefs];

            if (index === initialPositionRefs.length) {
                initialPositionRefs.push(node)
                areaCoverageProject.initialPositionsRefs = initialPositionRefs;
                this.setState({
                    areaCoverageProject
                })
            }
        } else if (this.state.selectedProjectType === "SCATTERED_REGIONS_VISITATION") {

            let scatteredRegionsVisitationProject = {...this.state.scatteredRegionsVisitationProject}

            let initialPositionRefs = [...scatteredRegionsVisitationProject.initialPositionsRefs];

            if (index === initialPositionRefs.length) {
                initialPositionRefs.push(node)
                scatteredRegionsVisitationProject.initialPositionsRefs = initialPositionRefs;
                this.setState({
                    scatteredRegionsVisitationProject
                })
            }
        }

    }


    setAreaOfInterestRef = (node) => {

        if (node == null) {
            return;
        }

        if (this.state.areaCoverageProject.areaOfInterestRef === null) {
            this.setState({
                areaCoverageProject: {
                    ...this.state.areaCoverageProject,
                    areaOfInterestRef: node
                },
            })
        }
    }

    setNoFlyZonePolygonRef = (node, index) => {

        if (node == null) {
            return;
        }

        let noFlyZonesRefs = this.state.areaCoverageProject.noFlyZonesRefs;

        if (index === noFlyZonesRefs.length) {
            noFlyZonesRefs = [...noFlyZonesRefs, node];
            this.setState({
                areaCoverageProject: {
                    ...this.state.areaCoverageProject,
                    noFlyZonesRefs
                }
            })
        }


    }

    setScatteredRegionsOfInterestRefs = (node, index) => {

        if (node == null) {
            return;

        }

        let scatteredRegionsOfInterestRefs = this.state.
            scatteredRegionsVisitationProject.scatteredRegionsOfInterestRefs;


        if (index === scatteredRegionsOfInterestRefs.length) {
            scatteredRegionsOfInterestRefs = [...scatteredRegionsOfInterestRefs, node];
            this.setState({
                scatteredRegionsVisitationProject: {
                    ...this.state.scatteredRegionsVisitationProject,
                    scatteredRegionsOfInterestRefs
                }
            })
        }
    };



    onRemoveNoFlyZone = (index) => {


        let project = {...this.state.areaCoverageProject}

        let noFlyZones = []

        project.noFlyZonesRefs.forEach(noFlyZoneRef => {
            if (noFlyZoneRef.props.myIndex !== index) {
                noFlyZones.push(noFlyZoneRef.getPath().getArray());
            }
        })

        this.setState({
            areaCoverageProject: {
                ...project,
                noFlyZones,
                noFlyZonesRefs: [],
                areaCoveragePaths: []
            }
        })
    }

    deletePolygon = (index) => {

        let project = {...this.state.scatteredRegionsVisitationProject}
        let scatteredRegionsOfInterestRefs = [...project.scatteredRegionsOfInterestRefs]
        let scatteredRegionsOfInterest = []
        scatteredRegionsOfInterestRefs.forEach(polygon => {

            if (polygon.props.myIndex !== index) {
                scatteredRegionsOfInterest.push(polygon.getPath().getArray());
            }
        })

        this.setState({
            scatteredRegionsVisitationProject: {
                ...project,
                scatteredRegionsOfInterest,
                scatteredRegionsOfInterestRefs: [],
                scatteredRegionsVisitationPaths: [],
                fov: null
            }
        })
    }





    convertInitialUAVPositionRefToInitialPosition = () => {

        if (this.state.initialUAVPosition) {
            const initialPosition = this.state.initialUAVPositionRef.getPosition();
            return [initialPosition.lat(), initialPosition.lng()];
        }
        return this.state.initialUAVPosition;
    }

    onExecuteAreaCoverageCalculatePaths = (evt) => {
        if (!_.isEmpty(this.state.deploymentAreaCoverageFormErrors)) {
            this.setState({})
            return;
        }



        this.setState({
            loading: true,
            darpLoading: true,
        })

        console.log(this.state.areaCoverageProject)

        if (this.state.selectedProjectType === 'AREA_COVERAGE') {

            axios.post('/api/v2/executeDARP', {
                numberOfDrones: this.state.areaCoverageProject.numberOfDrones,
                scanningDensity: computeScanningDensity(this.state.areaCoverageProject.altitude, this.state.areaCoverageProject.percentageOfSidelap),
                areaOfInterest: convertRefToPolygonGeo(this.state.areaCoverageProject.areaOfInterestRef),
                noFlyZones: convertRefsToMultiPolygonGeo(this.state.areaCoverageProject.noFlyZonesRefs),
                pathsStrictlyInPoly: this.state.areaCoverageProject.pathsStrictlyInPoly,
                portions: this.state.areaCoverageProject.portions.map(portion => portion / 100),

                initialPositions: convertRefToMultiPointGeo(this.state.areaCoverageProject.initialPositionsRefs)
                // droneLocations: Object.keys(this.state.drones).map(key => {
                //     return {canonicalName: key, location: this.state.drones[key]}
                // }),
                // droneLocations: Object.keys(this.state.drones).map(key => {
                //         return this.state.drones[key].location
                //     }
                // )
            })
                .then(response => {

                    const darpResponse = response.data;
                    if (darpResponse.status === "cancelled") {
                        this.setState({
                            loading: false,
                            darpLoading: false,
                            //     openSnackbar: true,
                            //     snackbarErrorMessage: "Calculation cancelled",
                        })
                    } else {
                        let areaCoverageProject = {...this.state.areaCoverageProject}

                        if(darpResponse.areaCoveragePaths.length > 0) {
                            let [portions, areaCoveragePaths]
                                = transformAreaCoveragePathsFromGeoJSON(
                                darpResponse.areaCoveragePaths, darpResponse.numberOfDrones)
                            areaCoverageProject.portions = portions
                            areaCoverageProject.areaCoveragePaths = areaCoveragePaths
                            areaCoverageProject.numberOfDrones = darpResponse.numberOfDrones
                            areaCoverageProject.initialPositions = areaCoverageProject.initialPositions.splice(
                                areaCoverageProject.initialPositions.length - darpResponse.numberOfDrones, darpResponse.numberOfDrones
                            )
                            areaCoverageProject.initialPositionsRefs = []

                            areaCoverageProject.areaCoveragePathColors = areaCoverageProject.areaCoveragePaths.map(_ => {
                                return getRandomColor();
                            });
                        }

                        this.setState({
                            areaCoverageProject,
                            runDeploymentButtonDisabled: false,
                            loading: false,
                            darpLoading: false,
                        })
                    }
                })
                .catch(error => {
                    this.setState({
                        loading: false,
                        darpLoading: false,
                        openSnackbar: true,
                        snackbarErrorMessage: error.message,
                    })
                })
        }
    };

    onExecuteTreeadsPathsClick = (evt) => {
        if (!_.isEmpty(this.state.deploymentAreaCoverageFormErrors)) {
            this.setState({})
            return;
        }



        this.setState({
            loading: true,
            darpLoading: true,
        })

        console.log(this.state.areaCoverageProject)

        if (this.state.selectedProjectType === 'AREA_COVERAGE') {

            axios.post('/api/executeTreeads', {
                numberOfDrones: this.state.areaCoverageProject.numberOfDrones,
                scanningDensity: computeScanningDensity(this.state.areaCoverageProject.altitude, this.state.areaCoverageProject.percentageOfSidelap),
                areaOfInterest: convertRefToPolygonGeo(this.state.areaCoverageProject.areaOfInterestRef),
                noFlyZones: convertRefsToMultiPolygonGeo(this.state.areaCoverageProject.noFlyZonesRefs),
                pathsStrictlyInPoly: this.state.areaCoverageProject.pathsStrictlyInPoly,
                portions: this.state.areaCoverageProject.portions.map(portion => portion / 100),

                initialPositions: convertRefToMultiPointGeo(this.state.areaCoverageProject.initialPositionsRefs)
                // droneLocations: Object.keys(this.state.drones).map(key => {
                //     return {canonicalName: key, location: this.state.drones[key]}
                // }),
                // droneLocations: Object.keys(this.state.drones).map(key => {
                //         return this.state.drones[key].location
                //     }
                // )
            })
                .then(response => {

                    const darpResponse = response.data;
                    if (darpResponse.status === "cancelled") {
                        this.setState({
                            loading: false,
                            darpLoading: false,
                            //     openSnackbar: true,
                            //     snackbarErrorMessage: "Calculation cancelled",
                        })
                    } else {
                        let areaCoverageProject = {...this.state.areaCoverageProject}

                        if(darpResponse.areaCoveragePaths.length > 0) {
                            let [portions, areaCoveragePaths]
                                = transformAreaCoveragePathsFromGeoJSON(
                                darpResponse.areaCoveragePaths, areaCoverageProject.numberOfDrones)
                            areaCoverageProject.portions = portions
                            areaCoverageProject.areaCoveragePaths = areaCoveragePaths
                            areaCoverageProject.areaCoveragePathColors = areaCoverageProject.areaCoveragePaths.map(_ => {
                                return getRandomColor();
                            });
                        }

                        this.setState({
                            areaCoverageProject,
                            runDeploymentButtonDisabled: false,
                            loading: false,
                            darpLoading: false,
                        })
                    }
                })
                .catch(error => {
                    this.setState({
                        loading: false,
                        darpLoading: false,
                        openSnackbar: true,
                        snackbarErrorMessage: error.message,
                    })
                })
        }
    };

    onExecuteScatteredRegionsCalculatePaths = (evt) => {

        console.log("scatteredRegionsVisitationProject: ", this.state.scatteredRegionsVisitationProject)


        this.setState({
            loading: true,
            executeScatteredRegionsLoading: true,
        })

        axios.post('/api/executeScatteredRegions', {



            scatteredRegionsOfInterest: convertRefsToMultiPolygonGeo(this.state.scatteredRegionsVisitationProject.scatteredRegionsOfInterestRefs),
            initialPositions: convertRefToMultiPointGeo(this.state.scatteredRegionsVisitationProject.initialPositionsRefs),
            projectName: this.state.scatteredRegionsVisitationProject.name,
            numberOfDrones: this.state.scatteredRegionsVisitationProject.numberOfDrones,
            droneType: this.state.scatteredRegionsVisitationProject.droneType,
            maxAltitude: this.state.scatteredRegionsVisitationProject.maxAltitude,
            minAltitude: this.state.scatteredRegionsVisitationProject.minAltitude,
            flightAltitude:this.state.scatteredRegionsVisitationProject.flightAltitude,
            horizontalSpeed: this.state.scatteredRegionsVisitationProject.horizontalSpeed,
            verticalSpeed: computeVerticalSpeed(this.state.dronesConfig,
                this.state.scatteredRegionsVisitationProject.droneType,
                this.state.scatteredRegionsVisitationProject.horizontalSpeed),
            hcoeff: this.state.scatteredRegionsVisitationProject.hcoeff,
            vcoeff: this.state.scatteredRegionsVisitationProject.vcoeff,
            safetyFactor: this.state.scatteredRegionsVisitationProject.safetyFactor,
            iouMetric: this.state.scatteredRegionsVisitationProject.iouMetric,

        })
            .then(response => {
                const calculateScatteredPathsResponse = response.data;
                if (calculateScatteredPathsResponse.status === "cancelled") {
                    this.setState({
                        loading: false,
                        executeScatteredRegionsLoading: false,
                        //     openSnackbar: true,
                        //     snackbarErrorMessage: "Calculation cancelled",
                    })
                } else {
                    let scatteredRegionsVisitationProject = {...this.state.scatteredRegionsVisitationProject}

                    scatteredRegionsVisitationProject.scatteredRegionsVisitationPaths = calculateScatteredPathsResponse.paths
                        .map(path => {
                            return {"waypoints": path.waypoints.map(waypoint => {return {
                                "elevation": waypoint.elevation,
                                "heading": waypoint.heading,
                                "waypoint": {
                                    "point": {
                                        "type": "Point",
                                        "coordinates": [waypoint.longitude, waypoint.latitude]
                                    },
                                    "altitude": waypoint.altitude,
                                },
                                "photo": waypoint.photo}})}
                        })
                    scatteredRegionsVisitationProject.scatteredRegionsVisitationPathColors = calculateScatteredPathsResponse.paths
                        .map(path => getRandomColor())

                    scatteredRegionsVisitationProject.fov = calculateScatteredPathsResponse.fov

                    this.setState({
                        scatteredRegionsVisitationProject,
                        runDeploymentButtonDisabled: false,
                        loading: false,
                        executeScatteredRegionsLoading: false,
                    })
                }
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    executeScatteredRegionsLoading: false,
                    openSnackbar: true,
                    snackbarErrorMessage: error.message,
                })
            })

    }

    onCancelDarpClick = (evt) => {
        axios.get('api/cancelPathCalculator');
    }


    calculateArea = () => {


        if(this.state.selectedProjectType === "AREA_COVERAGE") {

            let areaCoverageProject = {...this.state.areaCoverageProject}

            if (areaCoverageProject.areaOfInterestRef && areaCoverageProject.areaOfInterestRef.getPath()) {
                let path = areaCoverageProject.areaOfInterestRef.getPath();

                const area = window.google.maps.geometry.spherical.computeArea(path)

                let noFlyZonesArea = 0
                if (areaCoverageProject.noFlyZonesRefs) {
                    noFlyZonesArea = areaCoverageProject.noFlyZonesRefs.reduce(
                        (acc, polygon) => {
                            const obstacleArea = window.google.maps.geometry.spherical.computeArea(polygon.getPath())
                            return acc + obstacleArea
                        }, 0)
                }


                if (Math.abs(areaCoverageProject.areaOfInterestArea - (area - noFlyZonesArea)) > 5) {
                    console.log("recomputing area")
                    areaCoverageProject.areaCoveragePaths = []
                    areaCoverageProject.areaOfInterestArea = area - noFlyZonesArea
                    this.setState({
                        areaCoverageProject
                    })
                }


            }
        }

    };

    // updateDrones = (drone) => {
    //
    //     this.setState({
    //         dronesLive: {...this.state.dronesLive, [drone.canonicalName]: drone}
    //     });
    // };

    updateDroneTelemetry = (droneTelemetry) => {
        const serial = droneTelemetry.serial;

        if (!serial) return;

        this.setState({
            dronesLive: {
                ...this.state.dronesLive,
                [serial]: droneTelemetry
            },
            dronesSubscribed: {
                ...this.state.dronesSubscribed,
                [serial]: droneTelemetry
            }
        });
    };

    updateInfoSnackbar = (message) => {
        this.setState({
            openSnackbar: true,
            snackbarErrorMessage: message,
        })
    }

    handleChange = name => event => {

        this.setState({...this.state, [name]: event.target.checked});
    };
    handleColorChange = color => {
        console.log(color)
        this.setState({...this.state, polygonBackgroundColor: color});
    };

    setEditingPolygons = (editing) => {
        this.setState({
            editingPolygons: editing
        })
    }

    onSnackBarClose = () => {
        this.setState({openSnackbar: false});
    };

    handleOnTabChange = (event, newValue) => {
        this.setState({tab: newValue});
    };

    isOpenSnackbar = (snackbar) => {
        console.log("hii from snackbar isopen: " + snackbar)
        return snackbar}



    render() {
        const {
            mapLocation,
            initialLocation,
            initialUAVPosition,
            resetOperationalArea,
            loading,
            darpLoading,
            runDeploymentButtonDisabled,
            dronesLive,
            polygonBackgroundColor,
            polygonBackgroundColorCheck,
            obstaclePaths,
            executeScatteredRegionsLoading,
        } = this.state;

        // console.log("Estimated mission Time: ", this.state.estimatedMissionTime);

        const {classes} = this.props;
        const disabledPaperClasses = runDeploymentButtonDisabled ? {
            cursor: 'not-allowed',
            marginTop: '10px'
        } : {marginTop: '10px'};


        return (
            <div>
                <div>
                    {(darpLoading) ? <LinearProgress style={{flexGrow: 1}}/> : false}
                    {/*<Header/>*/}
                    <div
                        style={{position: 'fixed', left: 0, top: 0, width: '22vw', height: '100vh', overflowY: 'auto'}}>
                        <Sidebar projects={this.state.projects}
                                 getProjects={this.getProjects}
                                 onClickProject={this.onClickProject}
                                 onNewProject={this.onNewProject}
                                 selectedProjectType={this.state.selectedProjectType}
                                 project={this.state.selectedProjectType === 'AREA_COVERAGE' ? this.state.areaCoverageProject :
                                     this.state.selectedProjectType === 'SCATTERED_REGIONS_VISITATION' ?
                                         this.state.scatteredRegionsVisitationProject : null}
                                 onSaveAreaCoverageProject={this.onSaveAreaCoverageProject}
                                 onSaveScatteredRegionsVisitationProject={this.onSaveScatteredRegionsVisitationProject}
                                 onNumberOfDronesChange={this.onNumberOfDronesChange}
                                 onPortionsChange={this.onPortionsChange}
                                 onProjectChange={this.onProjectChange}
                                 onProjectCheckboxChange={this.onProjectCheckboxChange}
                                 deploymentAreaCoverageForm={this.state.deploymentAreaCoverageForm}
                                 onDeploymentAreaCoverageFormChange={this.onDeploymentAreaCoverageFormChange}
                                 deploymentAreaCoverageFormErrors={this.state.deploymentAreaCoverageFormErrors}
                                 onStartDeployment={this.onStartDeployment}
                                 onAbortExperiment={this.onAbortExperiment}
                                 onResetRegionOfInterest={this.onResetRegionOfInterest}
                                 onExecuteAreaCoverageCalculatePaths={this.onExecuteAreaCoverageCalculatePaths}
                                 onExecuteTreeadsPathsClick={this.onExecuteTreeadsPathsClick}
                                 onExecuteScatteredRegionsCalculatePaths={this.onExecuteScatteredRegionsCalculatePaths}
                                 executeScatteredRegionsLoading={executeScatteredRegionsLoading}
                                 numberOfDronesChangeLoading={this.state.numberOfDronesChangeLoading}
                                 onCancelDarpClick={this.onCancelDarpClick}
                                 onAddNoFlyZoneClick={this.onAddNoFlyZoneClick}
                                 onAddPolygonClick={this.onAddPolygonClick}
                                 darpLoading={darpLoading}
                                 dronesSubscribed={this.state.dronesSubscribed}
                                 dronesConfig={this.state.dronesConfig}
                                 runDeploymentButtonDisabled={this.state.runDeploymentButtonDisabled}
                                 calculateEstimatedDeploymentTime={this.calculateEstimatedDeploymentTime}
                                 estimatedDeploymentTime={this.state.estimatedDeploymentTime}
                                 editingPolygons={this.state.editingPolygons}
                                 setEditingPolygons={this.setEditingPolygons}
                                 dronesLive={this.state.dronesLive}
                                 droneStatuses={this.state.droneStatuses}
                                 deploymentStatus={this.state.deploymentStatus}

                        />
                    </div>


                    <div>
                        {this.state.editingPolygons === false ?
                            (
                                <Tabs style={{
                                    position: 'fixed',
                                    right: 0,
                                    top: 0,
                                    width: '78vw',
                                    height: '2vh',
                                    marginRight: '0'
                                }} value={this.state.tab} onChange={this.handleOnTabChange}
                                      aria-label="simple tabs example"
                                      indicatorColor={"primary"}>
                                    <Tab label="Map" {...a11yProps(0)} />
                                    <Tab label="Livestream" {...a11yProps(1)} />
                                </Tabs>) : null}

                        <div role="tabpanel"
                             hidden={this.state.tab !== 0}
                             id={`simple-tabpanel-0`}
                             aria-labelledby={`simple-tab-0`}>

                            <div className={'effect8'}
                                 style={this.state.editingPolygons === false ? {
                                     ...mapCss,
                                     marginTop: '5.5vh'
                                 } : mapCss}>
                                <CustomMap
                                    project={this.state.selectedProjectType === "AREA_COVERAGE"? this.state.areaCoverageProject : this.state.scatteredRegionsVisitationProject}
                                    mapLocation={mapLocation}
                                    initialLocation={initialLocation}
                                    initialUAVPosition={initialUAVPosition}
                                    resetOperationalArea={resetOperationalArea}
                                    loading={loading}
                                    setMapRef={this.setMapRef}
                                    setInitialPositionRef={this.setInitialPositionRef}
                                    setAreaOfInterestRef={this.setAreaOfInterestRef}
                                    setNoFlyZonePolygonRef={this.setNoFlyZonePolygonRef}
                                    setScatteredRegionsOfInterestRefs={this.setScatteredRegionsOfInterestRefs}
                                    onSearchBoxSelection={this.onSearchBoxSelection}
                                    refreshDronesSubscribed={this.refreshDronesSubscribed}
                                    dronesLive={dronesLive}
                                    dronesSubscribed={this.state.dronesSubscribed}
                                    dronesConfig={this.state.dronesConfig}
                                    initialPositionsRefs={this.state.areaCoverageProject.initialPositionsRefs}
                                    polygonBackgroundColor={polygonBackgroundColor}
                                    polygonBackgroundColorCheck={polygonBackgroundColorCheck}
                                    obstaclePaths={obstaclePaths}

                                    onRemoveNoFlyZone={this.onRemoveNoFlyZone}
                                    deletePolygon={this.deletePolygon}
                                    editingPolygons={this.state.editingPolygons}

                                />
                            </div>
                            <Paper style={this.state.editingPolygons === false ? {
                                ...searchBoxCss,
                                marginTop: '5.5vh'
                            } : searchBoxCss}>
                                <PlacesWithStandaloneSearchBox onSearchBoxSelection={this.onSearchBoxSelection}/>
                            </Paper>
                        </div>
                        <div role="tabpanel"
                             hidden={this.state.tab !== 1}
                             id={`simple-tabpanel-1`}
                             aria-labelledby={`simple-tab-1`}>
                            <div style={{
                                marginTop: '5.5vh',
                                marginLeft: '22.5vw',
                                display: 'flex',
                                flexWrap: 'wrap'
                            }}>
                                {Object.keys(this.state.dronesSubscribed).length !== 0 ?

                                    Object.keys(this.state.dronesSubscribed).map(key => {
                                        console.log("this.sdafsadf")
                                        const droneSubscribed = this.state.dronesSubscribed[key];

                                        const drone = dronesLive[key];
                                        // let drone = {canonicalName: "dji.phantom.4.pro.hawk.1"}
                                        return drone ? (
                                            <div style={{padding: '10px'}}>
                                                <LivePlayer
                                                    src={drone.canonicalName === "dji.phantom.4.pro.hawk.1" ?
                                                        // "http://" + nginxHLS + ":" + nginxHLSport + "/hls/dji.phantom.4.pro.hawk.1.m3u8"
                                                        "http://localhost:8090/hls/dji.phantom.4.pro.hawk.1.m3u8"
                                                        // "http://160.40.53.196:8090/hls/dji.phantom.4.pro.hawk.1.m3u8"
                                                        // "http://192.168.1.20:8090/hls/dji.phantom.4.pro.hawk.1.m3u8"
                                                        : "http://160.40.53.196:8090/hls/dji.phantom.4.pro.hawk.2.m3u8"}
                                                    canonicalName={drone.canonicalName}
                                                />
                                            </div>
                                        ) : null
                                    }) : (
                                        <div style={{padding: '10px'}}>
                                            {/*<LivePlayer*/}
                                            {/*    src={"http://160.40.53.196:8090/hls/dji.phantom.4.pro.hawk.1.m3u8"}*/}
                                            {/*    canonicalName={"dji.phantom.4.pro.hawk.1"}*/}
                                            {/*/>*/}
                                        </div>
                                    )}

                            </div>

                        </div>
                    </div>

                    <Snackbar

                        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                        key={'bottom,right'}
                        open={this.isOpenSnackbar(this.state.openSnackbar)}
                        onClose={this.onSnackBarClose}
                        // autoHideDuration={2000}
                    >
                        <SnackbarContent
                            style={{backgroundColor: '#d32f2f'}}
                            message={<span id="message-id" style={{display: 'flex', alignItems: 'center'}}>
                            <ErrorIcon style={{fontSize: 20, opacity: 0.9, marginRight: '3px'}}/>
                                {this.state.snackbarErrorMessage}
                        </span>}
                            action={[
                                <IconButton key="close" aria-label="Close" color="inherit"
                                            onClick={this.onSnackBarClose}>
                                    <CloseIcon/>
                                </IconButton>,
                            ]}
                        >
                        </SnackbarContent>

                    </Snackbar>
                </div>

            </div>
        )
    }

    refreshDroneTelemetry = () => {
        axios.get('/api/drone-telemetry').then(res => {
            this.setState({
                dronesSubscribed: res.data,
                dronesLive: res.data
            });
        });
    };

}


export default Main;
